(function($) {

"use strict";

/** --------------------------------------------------
 * 
 *   temp fixes - REGISTER FILE REQUIRED
 *
 *   INFO
 *   check to see if a file has been uploaded in the
 *   file upload on the register page
 *
 *   TABLE OF CONTENTS
 *   drupal behavior
 *   check file upload
 *   helper functions
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
 *  #drupal behavior
 *  -------------------------------------------------- */

Drupal.behaviors.tempfixRegisterFileRequired = {
	attach: function (context, settings) {

		/* if(isUserAccountPage()) {
			checkFileUpload();
		} */

	}
};



/** --------------------------------------------------
 *  #check file upload
 *  -------------------------------------------------- */

function checkFileUpload() {
	const $body = $('body');

	// remove body classes that might get added below:
	$body.removeClass('js-file-upload--visible');
	$body.removeClass('js-file-upload--has-file');
	$body.removeClass('js-file-upload--no-file');

	// get the submit-button of the form and enable it if it is disabled:
	const $submitButton = $(document).find('.form-actions .form-submit');
	if($submitButton.length > 0) {
		$submitButton.removeAttr('disabled');
	}

	// get the activity block and get the file upload:
	const $activityBlock = $(document).find('fieldset[data-drupal-selector="edit-your-activity"]');
	if($activityBlock.length > 0) {

		const $fileUploadBlock = $activityBlock.find('.form-managed-file');
		if($fileUploadBlock.length > 0) {
			 if($fileUploadBlock.parents('.hidden').length === 0) {
				// -> there is a visible file upload:
				$body.addClass('js-file-upload--visible');
				const $fileLinkBlock = $activityBlock.find('.file > a');
				// -> check if there is a file or not:
				if($fileLinkBlock.length > 0) {
					$body.addClass('js-file-upload--has-file');
				} else {
					// --> no file: add class to body to remove some form elements
					//     and disable the submit button (because it won't work when
					//     some of the form items are hidden):
					$body.addClass('js-file-upload--no-file');
					if($submitButton.length > 0) {
						$submitButton.attr('disabled', true);
					}
				}
			} 
			
		}

	}
}




/** --------------------------------------------------
 *  #helper functions
 *  -------------------------------------------------- */

function isUserAccountPage() {
	let isUserPage = false;

	if($('body').hasClass('path-user')) {
		isUserPage = true;
	}

	return isUserPage;
} /* isUserAccountPage */




})(jQuery);
